


































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';

import WrapperArrows from './WrapperArrows.vue'

import ButtonSelectSimple from '@/components/select/ButtonSelectSimple.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { TYPE_OPTIONS } from './consts';
import { CalendarType } from '@/components/calendar/types';

@Component({
    components: {
        WrapperArrows,
        BaseButton,
        ButtonSelectSimple,
    },
})
export default class CalendarHeader extends Vue {
    @Prop({ default: '' }) readonly title!: string
    @Prop({ default: false, type: Boolean }) readonly disabledType!: boolean
    @PropSync('type') typeWrapper!: CalendarType

    get typeOptions() {
        return TYPE_OPTIONS;
    }

    goBack() {
        this.$emit('date:back')
    }

    goNext() {
        this.$emit('date:next')
    }

    resetDate() {
        this.$emit('date:today')
    }
}
